export const PRODUCT_SIZES = ["30", "100", "500", "1000"];